module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_mycatalog-43f81d7c8af6a6d1a2a6db23090770c9.png";